import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/WithRouter';
import withRouterParams from '../../utils/WithRouterParams';
import { getTranslations } from '../../services/languageUtils';

import Step1 from './steps/step1';
import Step2 from './steps/step2';
import Step3 from './steps/step3';
import Step4 from './steps/step4';
import Step5 from './steps/step5';

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enableViewPassword: true,
      step: 1,

      name: (this.props.params.name !== undefined?this.props.params.name:''),
      phone: (this.props.params.phone !== undefined?this.props.params.phone:''),
      email: (this.props.params.email !== undefined?this.props.params.email:''),
      doc: '',
      birthDate: '',
      rg: '',
      zipcode: '',
      street: '',
      district: '',
      state: '',
      number: '',
      neighborhood: '',
      country: '',
      city: '',
      password: '',
      motherName: '',
      pin: '',
      isPoliticallyExposedPerson: false,

      dangerName: false,
      dangerPhone: false,
      dangerEmail: false,

      token: (this.props.params.token !== undefined?this.props.params.token:''),

      style: {height: '1300px', minHeight: "105vh"},

      translations: {}
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();
    let status = this.gup("status");
    if(status === "under_analysis")
      this.setState({step: 7});
  }

  gup(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[]/,"\\[").replace(/[\]]/,"\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( url );
    return results == null ? '' : results[1];
  }

  getCookie(name) {
      var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      if (match) {
        return match[2];
      }
   }

  changeStep(value) {
    this.setState({step: value});
  }

  sendActiveEvent(event) {

  }

  setWidthStep(value) {
    const container = document.getElementById('mainContent');
    container.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    let that = this;
    if(value === 1){
      that.setState({step: value, style: {height: '2000px', minHeight: "105vh"}});
    }
    else if(value === 2){
      that.setState({step: value, style: {height: '1500px', minHeight: "105vh"}});
    }
    else if(value === 3){
      that.setState({step: value, style: {height: '1800px', minHeight: "105vh"}});
    }
    else if(value === 4){
      that.setState({step: value, style: {height: '2500px', minHeight: "105vh"}});
    }
    else if(value === 5){
      that.setState({step: value, style: {height: '1700px', minHeight: "105vh"}});
    }
    else {
      window.location.href = '/login';
    }
  }

  saveRegister() {

  }

  onChangeValue = event => {
    switch(event.target.name){
      case 'office':
        this.setState({office: event.target.value, dangerOffice: false});
        break;
      case 'name':
        this.setState({name: event.target.value, dangerName: false});
        break;
      case 'doc':
        this.maskDoc(event.target.value);
        this.setState({dangerDoc: false});
        break;
      case 'email':
        this.setState({email: event.target.value, dangerEmail: false});
        break;
      case 'password':
        this.setState({password: event.target.value});
        break;
      case 'pin':
        this.setState({pin: event.target.value});
        break;
      case 'typeStep':
        this.setState({typeStep: event.target.value});
        break;
      case 'step':
        if(event.target.value === 10 || event.target.value === 7){
          let that = this;
          this.setState({continue: true}, ()=>{
              that.changeStep(event.target.value);
          })
        }
        else
          this.changeStep(event.target.value);
        this.setWidthStep(event.target.value);
        break;
      case 'isPoliticallyExposedPerson':
        this.setState({isPoliticallyExposedPerson: event.target.value});
        break;
      case 'birthDate':
        this.setState({ birthDate: event.target.value || "" });
        break;
      case 'phone':
        this.setState({phone: event.target.value, dangerPhone: false});
        break;
      case 'zipcode':
        this.setState({zipcode: event.target.value});
        break;
      case 'street':
        this.setState({street: event.target.value});
        break;
      case 'number':
        this.setState({number: event.target.value});
        break;
      case 'district':
        this.setState({district: event.target.value});
        break;
      case 'city':
        this.setState({city: event.target.value});
        break;
      case 'country':
        this.setState({country: event.target.value});
        break;
      case 'motherName':
        this.setState({motherName: event.target.value});
        break;
      case 'state':
        this.setState({state: event.target.value});
        break;
      case 'inputValueStates':
        this.setState({inputValueStates: event.target.value});
        break;
      case 'setWidth':
        this.setState({style: {height: event.target.value}});
        break;

      default:
        break;
    }
  }

  maskCNPJ(doc) {
      var value = doc;
      var returnValue = value.replace(/\D/g, "");
      if (returnValue.length > 12) {
        returnValue = returnValue.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2}).*/, "$1.$2.$3/$4-$5");
      }
      else if (returnValue.length > 9) {
        returnValue = returnValue.replace(/^(\d{2})(\d{3})(\d{3})(\d{0,4}).*/, "$1.$2.$3/$4");
      }
      else if (returnValue.length > 6) {
        returnValue = returnValue.replace(/^(\d{2})(\d{3})(\d{0,3})/, "$1.$2.$3");
      }
      else if (returnValue.length > 3) {
        returnValue = returnValue.replace(/^(\d{2})(\d{0,3})/, "$1.$2");
      }
      this.setState({doc: returnValue});
  }

  maskDoc(doc) {
    let value = doc;
    let retornValue = value.replace(/\D/g, "");
    if (retornValue.length > 9) {
      retornValue = retornValue.replace(/^(\d{3})(\d{3})(\d{3})(\d{0,2}).*/, "$1.$2.$3-$4");
    }
    else if (retornValue.length > 6) {
      retornValue = retornValue.replace(/^(\d{3})(\d{3})(\d{0,3})/, "$1.$2.$3");
    }
    else if (retornValue.length > 3) {
      retornValue = retornValue.replace(/^(\d{3})(\d{0,3})/, "$1.$2");
    }
    this.setState({doc: retornValue});
  }

  getCurrentStatusStyle() {
    if(this.state.step === 1 )
      return {width: "16%"};
    else if(this.state.step === 2 )
      return {width: "48%"};
    else if(this.state.step === 3 )
      return {width: "80%"};
    else if(this.state.step === 4 )
      return {width: "100%"};
    else if(this.state.step === 5 )
      return {width: "100%"};

    return {width: "0%"};
  }

  render() {
    return (
      <section id="mainContent" className="mainContent registerPage">
        <div className="sideLeftContent"  style={this.state.style}>
            <div className="textContent">
              <div className="logoLeft">
                <img src={require("../../assets/imgs/ico-higher-bg.svg").default} alt={this.state.translations.iconHigher} className="iconHigherImage"/>
                {this.state.translations.higher}<b>{this.state.translations.bank}</b>
              </div>
              <p className="h5" style={{margin: "-15px 0px 20px 30px"}}>{this.state.translations.welcomeToYourBank}</p><br/>
                <div>
                  <div className="contentNumbers" onClick={()=>{this.setWidthStep(1);}} style={{cursor: "pointer"}}>
                    <div className={"iconNumber " + (this.state.step >= 1?"iconNumberSelected":"")}>1</div> <div className={(this.state.step >= 1?"textNumberSelected":"textNumber")}>
                      {this.state.translations.identification}
                      {
                        this.state.step > 1 &&
                        <img src={require("../../assets/imgs/check.svg").default} alt={this.state.translations.filled} className="checkIcon"/>
                      }
                      {
                        this.state.step === 1 &&
                        <img src={require("../../assets/imgs/seta-right-branca.svg").default} alt={this.state.translations.filled} className="checkIcon"/>
                      }
                    </div>
                  </div>
                  <div className="contentNumbers" onClick={()=>{this.setWidthStep(2);}} style={{cursor: "pointer"}}>
                    <div className={"iconNumber " + (this.state.step >= 2?"iconNumberSelected":"")}>2</div> <div className={(this.state.step >= 2?"textNumberSelected":"textNumber")}>
                      {this.state.translations.address}
                      {
                        this.state.step > 2 &&
                        <img src={require("../../assets/imgs/check.svg").default} alt={this.state.translations.filled} className="checkIcon"/>
                      }
                      {
                        this.state.step === 2 &&
                        <img src={require("../../assets/imgs/seta-right-branca.svg").default} alt={this.state.translations.filled} className="checkIcon"/>
                      }
                    </div>
                  </div>
                  <div className="contentNumbers" onClick={()=>{this.setWidthStep(3);}} style={{cursor: "pointer"}}>
                    <div className={"iconNumber " + (this.state.step >= 3?"iconNumberSelected":"")}>3</div> <div className={(this.state.step >= 3?"textNumberSelected":"textNumber")}>
                      {this.state.translations.accountAccess}
                      {
                        this.state.step > 3 &&
                        <img src={require("../../assets/imgs/check.svg").default} alt={this.state.translations.filled} className="checkIcon"/>
                      }
                      {
                        this.state.step === 3 &&
                        <img src={require("../../assets/imgs/seta-right-branca.svg").default} alt={this.state.translations.filled} className="checkIcon"/>
                      }
                    </div>
                  </div>
                  <div className="contentNumbers" onClick={()=>{this.setWidthStep(4);}} style={{cursor: "pointer"}}>
                    <div className={"iconNumber " + (this.state.step >= 4?"iconNumberSelected":"")}>4</div> <div className={(this.state.step >= 4?"textNumberSelected":"textNumber")}>
                      {this.state.translations.documentation}
                      {
                        this.state.step > 4 &&
                        <img src={require("../../assets/imgs/check.svg").default} alt={this.state.translations.filled} className="checkIcon"/>
                      }
                      {
                        this.state.step === 4 &&
                        <img src={require("../../assets/imgs/seta-right-branca.svg").default} alt={this.state.translations.filled} className="checkIcon"/>
                      }
                    </div>
                  </div>
                </div>
              <br/>
              <p className="h3">{this.state.translations.higherBankCommitment}</p><br/>
              <p className="h4">{this.state.translations.yourDataIsProtected}</p>
              <br/><br/>
              <p className="h4">{this.state.translations.authorizedForeignExchangeCorrespondent}</p>
              <br/>
              <img src={require("../../assets/imgs/banco-central-do-brasil-logo-3@2x-white.png")} style={{height: "40px"}} alt={this.state.translations.centralBank} />
            </div>
        </div>
        <div className="sideLeftContentMobile" style={{padding: "5px 0px 3px 0px"}}>
          <div className="logoLeft" style={{color: "#fff", textAlign: "center", fontSize: "22px"}}>
            <img src={require("../../assets/imgs/ico-higher-bg.svg").default} alt={this.state.translations.iconHigher} style={{height:"52px"}} className="iconHigherImage"/>
            {this.state.translations.higher} <b>{this.state.translations.bank}</b>
          </div>
        </div>

        {
          this.state.step !== 0 &&
          <div className="contentStatus">
            <p className="h1">{this.state.translations.progress}</p>
            <div className="contentStatusBar">
              <div className="contentStatusCurrent" style={this.getCurrentStatusStyle()}>
              </div>
            </div>
          </div>
        }

        {
          this.state.step === 1 &&
          <Step1
            name={this.state.name}
            phone={this.state.phone}
            motherName={this.state.motherName}
            email={this.state.email}
            doc={this.state.doc}
            birthDate={this.state.birthDate}
            isPoliticallyExposedPerson={this.state.isPoliticallyExposedPerson}
            onChangeValue={this.onChangeValue}
            sendActiveEvent={this.sendActiveEvent}
          />
        }
        {
          this.state.step === 2 &&
          <Step2
            zipcode={this.state.zipcode}
            street={this.state.street}
            number={this.state.number}
            district={this.state.district}
            state={this.state.state}
            city={this.state.city}
            onChangeValue={this.onChangeValue}
            sendActiveEvent={this.sendActiveEvent}
          />
        }
        {
          this.state.step === 3 &&
          <Step3
            pin={this.state.pin}
            password={this.state.password}
            confirmPass={this.state.confirmPass}
            onChangeValue={this.onChangeValue}
            sendActiveEvent={this.sendActiveEvent}
          />
        }
        {
          this.state.step === 4 &&
          <Step4
            name={this.state.name}
            phone={this.state.phone}
            email={this.state.email}
            doc={this.state.doc}
            password={this.state.password}
            pin={this.state.pin}
            zipcode={this.state.zipcode}
            street={this.state.street}
            number={this.state.number}
            district={this.state.district}
            state={this.state.state}
            city={this.state.city}
            isPoliticallyExposedPerson={this.state.isPoliticallyExposedPerson}
            birthDate={this.state.birthDate}
            motherName={this.state.motherName}
            onChangeValue={this.onChangeValue}
            sendActiveEvent={this.sendActiveEvent}
          />
        }
        {
          this.state.step === 5 &&
          <Step5
            onChangeValue={this.onChangeValue}
          />
        }
      </section>
    );
  }
}

export default withRouterParams(withRouter(Register));
